import { ReactNode } from 'react';
import { Box, Chip, Stack, Typography } from '@mui/material';
import { CHIP_OVERLINE_SX } from './sharedStyles';

type Props = {
  title: string;
  description: string;
  accent?: 'primary' | 'secondary';
  active?: boolean;
  badge?: string | null;
  priceLine?: ReactNode;
  extra?: ReactNode;
  right?: ReactNode;
};

// Shared header for the checkout add-on / Signal Manager cards: accent dot + title
// (optional active chip) + description + price line + optional right control.
export function AddonCardHeader({ title, description, accent = 'primary', active, badge, priceLine, extra, right }: Props) {
  return (
    <Stack direction="row" alignItems="center" spacing={2}>
      <Box sx={{ width: 8, height: 8, borderRadius: '50%', flexShrink: 0, bgcolor: active ? `${accent}.main` : 'divider' }} />
      <Stack spacing={0.4} sx={{ flex: 1, minWidth: 0 }}>
        <Stack direction="row" alignItems="center" spacing={1} flexWrap="wrap">
          <Typography variant="body2" fontWeight={700}>
            {title}
          </Typography>
          {badge && <Chip size="small" color="success" label={badge} sx={CHIP_OVERLINE_SX} />}
        </Stack>
        <Typography variant="caption" color="text.secondary" sx={{ lineHeight: 1.45 }}>
          {description}
        </Typography>
        {priceLine != null && (
          <Typography variant="body2" fontWeight={700} color={`${accent}.main`}>
            {priceLine}
          </Typography>
        )}
        {extra}
      </Stack>
      {right}
    </Stack>
  );
}
